export const API_URL = "https://backend.losersmagnifiques.com/api/"

export const userData = [
    {
        name: "Jan",
        "Active User": 4000,
    },
    {
        name: "Feb",
        "Active User": 3000,
    },
    {
        name: "Mar",
        "Active User": 5000,
    },
    {
        name: "Apr",
        "Active User": 4000,
    },
    {
        name: "May",
        "Active User": 3000,
    },
    {
        name: "Jun",
        "Active User": 2000,
    },
    {
        name: "Jul",
        "Active User": 4000,
    },
    {
        name: "Agu",
        "Active User": 3000,
    },
    {
        name: "Sep",
        "Active User": 4000,
    },
    {
        name: "Oct",
        "Active User": 1000,
    },
    {
        name: "Nov",
        "Active User": 4000,
    },
    {
        name: "Dec",
        "Active User": 3000,
    },
]

export const productData = [
    {
        name: "Jan",
        "Sales": 4000,
    },
    {
        name: "Feb",
        "Sales": 3000,
    },
    {
        name: "Mar",
        "Sales": 5000,
    },
]

export const userRows = [
    {
        id: 1,
        username: "Jon Snow",
        avatar:
            "https://avatars.githubusercontent.com/u/119888833?v=4",
        email: "jon@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 2,
        username: "Jon Snow",
        avatar:
            "https://avatars.githubusercontent.com/u/119888833?v=4",
        email: "jon@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 3,
        username: "Jon Snow",
        avatar:
            "https://avatars.githubusercontent.com/u/119888833?v=4",
        email: "jon@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 4,
        username: "Jon Snow",
        avatar:
            "https://avatars.githubusercontent.com/u/119888833?v=4",
        email: "jon@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 5,
        username: "Jon Snow",
        avatar:
            "https://avatars.githubusercontent.com/u/119888833?v=4",
        email: "jon@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 6,
        username: "Jon Snow",
        avatar:
            "https://avatars.githubusercontent.com/u/119888833?v=4",
        email: "jon@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 7,
        username: "Jon Snow",
        avatar:
            "https://avatars.githubusercontent.com/u/119888833?v=4",
        email: "jon@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 8,
        username: "Jon Snow",
        avatar:
            "https://avatars.githubusercontent.com/u/119888833?v=4",
        email: "jon@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 9,
        username: "Jon Snow",
        avatar:
            "https://avatars.githubusercontent.com/u/119888833?v=4",
        email: "jon@gmail.com",
        status: "active",
        transaction: "$120.00"
    },
    {
        id: 10,
        username: "Jon Snow",
        avatar:
            "https://avatars.githubusercontent.com/u/119888833?v=4",
        email: "jon@gmail.com",
        status: "active",
        transaction: "$120.00"
    }
]
